import script from "./OperatorApplicationSuggestedTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationSuggestedTemplates.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationSuggestedTemplates.vue?vue&type=style&index=0&id=295db168&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295db168"]])

export default __exports__